import { Component } from 'react';

import './smart-error-console.css';

class SmartErrorConsole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  update(e) {
    const { on_change, config } = this.props;
    const newValue = e.target.value;

    const inputName = config.name;
    this.setState({ value: newValue });
    on_change(inputName, newValue);
  }

  printErrors() {
    const { errors } = this.props;

    let i = 0;
    return errors.map((error) => {
      const errorKey = 'error' + i++;
      return (
        <div className="smart_form_error" key={errorKey}>
          {error}
        </div>
      );
    });
  }

  render() {
    return <div className="smart_form_error_console">{this.printErrors()}</div>;
  }
}

export default SmartErrorConsole;
